import { GET_LIST_REQUEST_DEFAULT_LIMIT } from "constants/common";
/* eslint-disable react-hooks/exhaustive-deps */
import { useManageTable } from "hooks";
import { GetListRequestParams } from "libs/api";

import { useFeedInserts } from "../apis";

const useFeedInsertsList = () => {
  const {
    page,
    searchValue,
    debouncedSearch,
    sorting,
    setSorting,
    setSearchValue,
    setPage
  } = useManageTable();

  const requestParams: GetListRequestParams = {
    page,
    take: GET_LIST_REQUEST_DEFAULT_LIMIT,
    search: debouncedSearch,
    orderBy: sorting[0]?.id,
    order: sorting[0] ? (sorting[0]?.desc ? "DESC" : "ASC") : undefined
  };

  const { feedInserts, meta, isLoading, setFeedInserts } =
    useFeedInserts(requestParams);

  return {
    feedInserts,
    totalItems: meta?.itemCount ?? 0,
    searchValue,
    page,
    isLoading,
    sorting,
    setSorting,
    setSearchValue,
    setPage,
    setFeedInserts
  };
};

export default useFeedInsertsList;
